(() => {
  if (customElements.get('announcement-bar')) {
    return;
  }

  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.autoRotate = this.dataset.autoRotate
      this.options = {};

      this.playBtn = document.getElementById("playBtn");
      this.pauseBtn = document.getElementById("pauseBtn");
    }
  
    connectedCallback() {
      this.initSlider();

      // binding events
      this.pauseBtn.addEventListener("click", this.togglePlayPause.bind(this));
      this.pauseBtn.addEventListener("keydown", this.togglePlayPause.bind(this));
      this.playBtn.addEventListener("click", this.togglePlayPause.bind(this));
      this.playBtn.addEventListener("keydown", this.togglePlayPause.bind(this))
    }
  
    initSlider() {
      this.options = {
        slidesPerView: 1,
        loop: true,
        speed: 500,
        allowTouchMove: false,
        effect: "fade",
        fadeEffect: {
          crossFade: true
        }
      };

      if (this.autoRotate) {
        this.options.autoplay = {
          delay: Number(this.autoRotate)
        }
      }
  
      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }

    togglePlayPause(event) {
      if (event.type === "click" || event.key === "Enter" || event.key === " ") {
        event.preventDefault(); // Prevent page scrolling

        if (event.target.id === "pauseBtn") {
          this.slider.autoplay.stop();
          this.pauseBtn.setAttribute("aria-hidden", "true");
          this.pauseBtn.style.display = "none";
          this.playBtn.setAttribute("aria-hidden", "false");
          this.playBtn.style.display = "flex";
          this.playBtn.focus();
        } else {
          this.slider.autoplay.start();
          this.playBtn.setAttribute("aria-hidden", "true");
          this.playBtn.style.display = "none";
          this.pauseBtn.setAttribute("aria-hidden", "false");
          this.pauseBtn.style.display = "flex";
          this.pauseBtn.focus();
        }
      }
    }
  }
  
  customElements.define('announcement-bar', AnnouncementBar);
})();